<div class="dialog-frame">
  <header class="dialog-header">
    <div class="header-top">
      <mat-icon class="brand-icon">assignment_ind</mat-icon>
      <div class="title-group">
        <h1>Reasignar Especialista</h1>
        <div class="breadcrumb">
          <span class="client">{{data.clienteNombre}}</span>
          <mat-icon>navigate_next</mat-icon>
          <span class="local">{{data.localNombre}}</span>
        </div>
      </div>
    </div>
  </header>

  <div class="dialog-body">
    <div class="assignment-status" *ngIf="data.tecnicoActual">
      <div class="status-content">
        <span class="status-label">ASIGNACIÓN ACTUAL:</span>
        <span class="status-name">{{data.tecnicoActual.name}} {{data.tecnicoActual.lastName}}</span>
      </div>
    </div>

    <div class="search-box">
      <mat-form-field appearance="outline" class="full-width no-margin-bottom">
        <mat-label>Filtrar por nombre o RUT</mat-label>
        <input matInput [formControl]="tecnicoControl" [matAutocomplete]="auto" (click)="openPanel()" (focus)="openPanel()">
        
        <div matSuffix class="suffix-ui">
          <mat-icon *ngIf="tecnicoControl.value" class="clear-btn" (click)="tecnicoControl.setValue('')">close</mat-icon>
          <div class="divider"></div>
          <mat-icon class="search-icon">search</mat-icon>
        </div>

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="modern-table-panel">
          <div class="table-header">
            <span class="col-main">NOMBRE COMPLETO</span>
            <span class="col-side">RUT</span>
          </div>

          <mat-option *ngFor="let tecnico of filteredTecnicos$ | async" [value]="tecnico" class="table-row">
            <div class="table-content">
              <div class="name-cell">
                <span class="name-text">{{tecnico.name}} {{tecnico.lastName}}</span>
              </div>
              <div class="rut-cell">
                <span class="rut-text">{{tecnico.rut}}</span>
              </div>
            </div>
          </mat-option>

          <mat-option *ngIf="(filteredTecnicos$ | async)?.length === 0" disabled>
            No se encontraron técnicos.
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <footer class="dialog-footer">
    <button mat-button mat-dialog-close class="btn-cancel">CANCELAR</button>
    <button mat-raised-button color="primary" [disabled]="!tecnicoControl.value?.id" (click)="confirmar()" class="btn-confirm">
      ACTUALIZAR TÉCNICO
    </button>
  </footer>
</div>